module.exports = __webpack_public_path__ + "img/perks_F.56005007.jpg";